import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { fetchConfigurableLink } from 'app/actions/manage-configurable-link.actions';
import template from './configurable-link-widget.html';

const mapStateToThis = ({ manageConfigurableLink, session, dashboard }) => {
  const { isLoading, entries } = manageConfigurableLink;
  const { locale } = session;
  let isEmpty = true;
  let entry = {};
  if (entries.length > 0) {
    [entry] = entries;
    if (
      (entry.visibleOnSummary && dashboard.current.name === 'summary') ||
      (entry.visibleOnInstants && dashboard.current.name === 'instant')
    ) {
      isEmpty = false;
    }
  }

  return {
    locale,
    isLoading,
    isEmpty,
    entry,
  };
};

const mapDispatchToThis = {
  fetchConfigurableLink,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux')
class ConfigurableLinkWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.$scope.$applyAsync(this.fetchConfigurableLink(this.locale));
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class ConfigurableLinkWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = ConfigurableLinkWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/configurable-link/configurable-link-widget-component.js